import React from 'react'
import { Link } from 'react-router-dom'
import bg5 from '../../assets/images/background/bg-5.png'
import bg6 from '../../assets/images/background/bg-6.png'
import { useContent } from '../../services'
import analytics from '../../services/analytics'

function Book() {
    const { data: reservationData, loading: loadingR } = useContent('reservationContent');
    const { data: bizData, loading: loadingB } = useContent('businessInfo');

    if (loadingR || loadingB || !reservationData || !bizData) return null;

    return (
        <>
            <section className="online-reservation inner-page">
                <div className="left-bg"><img src={bg5} alt="" title="" /></div>
                <div className="right-bg"><img src={bg6} alt="" title="" /></div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle"><span>Reservation</span></div>
                        <div className="pattern-image"><img src={require('../../assets/images/icons/separator.svg').default} alt="" title="" /></div>

                        <h2>{reservationData.title || 'Book A Table'}</h2>
                        <div className="text desc">{reservationData.description}</div>
                        <div className="text request-info">For reservation booking requests call us at <Link to={bizData.phoneLink}>{bizData.phone}</Link> </div>
                    </div>
                    <div className="default-form reservation-form" style={{ textAlign: 'center' }}>
                        <a href={bizData.phoneLink} className="theme-btn btn-style-one clearfix" onClick={() => analytics.trackPhoneClick('reservation_page')}>
                            <span className="btn-wrap">
                                <span className="text-one">book a table</span>
                                <span className="text-two">book a table</span>
                            </span>
                        </a>
                    </div>
                </div>

                <div className="map-location-section">
                    <div className="auto-container">
                        <div className="outer-box">
                            <div className="row clearfix">
                                <div className="reserv-col col-lg-8 col-md-12 col-sm-12">
                                    <div className="inner">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3337.8108331535323!2d-96.90725762417627!3d33.219055161264556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c39f3634c8675%3A0xe2f2421124b04dc9!2sHuq%20Up!5e0!3m2!1sen!2sus!4v1772324843951!5m2!1sen!2sus" width="100%" height="600" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Huqup Location"></iframe>
                                    </div>
                                </div>
                                <div className="info-col col-lg-4 col-md-12 col-sm-12">
                                    <div className="inner">
                                        <div className="title">
                                            <h2>Little Elm, TX</h2>
                                        </div>
                                        <div className="data">
                                            <ul className="info">
                                                <li><strong>Contact Us</strong><br />{bizData.address}<br /> Call : {bizData.phone} <br /> Email : {bizData.email}</li>
                                                <div className="separator"><span></span></div>
                                                <li><strong>Opening Hours</strong><br />Sun – Thu : 11 AM – 2 AM<br />Fri – Sat : 11 AM – 3 AM</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default Book
